import script from "./QuesAns.vue?vue&type=script&setup=true&lang=js"
export * from "./QuesAns.vue?vue&type=script&setup=true&lang=js"

import "./QuesAns.vue?vue&type=style&index=0&id=af1e7888&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af1e7888"]])

export default __exports__